import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import {CopyToClipboard} from 'components/CopyToClipboard';

export interface IProps {
    id: string;
}

export const Article: FC<IProps> = ({id}) => {
    return (
        <CopyToClipboard className={style.button} copyText={id}>
            <div className={style.text}>
                <Typography variant={'label-14-r-fluid'}>Артикул: </Typography>
                <Typography variant={'label-14-r-fluid'}>{id}</Typography>
            </div>
        </CopyToClipboard>
    );
};
